// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OiA5","placeholdersHeader":"styles_placeholdersHeader__12sz8","editorStyle":"styles_editorStyle__3cOpz","placeholdersBox":"styles_placeholdersBox__UO5Ua"};